module.exports = __webpack_public_path__ + "img/11825384_L.57574599.png";